///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2020
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import types from "./types";

const {
  pastPlannedDeparture,
  silentOverThreeHours,
  atRiskOfLateArrival,
  atRiskOfMissingSortCutoff,
  estimatedToDepartNextLegLate,
  possibleImpact,
  shutdown,
} = types.alerts;

const alertByValueMap = {
  [pastPlannedDeparture.value]: pastPlannedDeparture,
  [silentOverThreeHours.value]: silentOverThreeHours,
  [atRiskOfLateArrival.value]: atRiskOfLateArrival,
  [atRiskOfMissingSortCutoff.value]: atRiskOfMissingSortCutoff,
  [estimatedToDepartNextLegLate.value]: estimatedToDepartNextLegLate,
  [possibleImpact.value]: possibleImpact,
  [shutdown.value]: shutdown,
};

export const mapLegAlerts = (legs) => {
  let legWithAlertFound = false;

  for (let leg of legs) {
    const hasAlert = leg.alerts.length > 0;

    if (legWithAlertFound && !hasAlert) {
      leg.alerts.push(possibleImpact);
    }

    if (hasAlert) {
      legWithAlertFound = true;
      leg.alerts = leg.alerts.map((value) => alertByValueMap[value]);
    }
  }
};
